import { token } from '@atlaskit/tokens';

type IconProps = {
	width?: string | number;
	height?: string | number;
};

export const UsersIcon = ({ width = '24', height = '24' }: IconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="2"
				y="2"
				width="24"
				height="24"
				rx="12"
				fill={token('elevation.surface.sunken')}
				fillOpacity="0.07"
			/>
			<rect
				x="1"
				y="1"
				width="26"
				height="26"
				rx="13"
				stroke={token('color.border.accent.gray')}
				strokeOpacity="0.4"
				strokeWidth="1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 7.5C12.6193 7.5 11.5 8.61929 11.5 10C11.5 11.3807 12.6193 12.5 14 12.5C15.3807 12.5 16.5 11.3807 16.5 10C16.5 8.61929 15.3807 7.5 14 7.5ZM10 10C10 7.79086 11.7909 6 14 6C16.2091 6 18 7.79086 18 10C18 12.2091 16.2091 14 14 14C11.7909 14 10 12.2091 10 10ZM8 19C8 16.9289 9.67893 15.25 11.75 15.25H16.25C18.3211 15.25 20 16.9289 20 19V21H18.5V19C18.5 17.7574 17.4926 16.75 16.25 16.75H11.75C10.5074 16.75 9.5 17.7574 9.5 19V21H8V19Z"
				fill={token('color.icon.accent.gray')}
			/>
		</svg>
	);
};
